// components/filters/FilterBase.js
import React, { useEffect } from "react";
import { useTabs } from "../hooks/useTabs";
import { listen } from "../hooks/Listener";
import { KBD } from "../utils/Keybindings";
import { ROUTES } from "../utils/Routes";
import { InfoIcon } from "../utils/Icons";
import Status from "../ui/Status";
export default function FilterBase(props) {

    const { controller = "", fields = [], initialValues = [], onSave = () => { }, onClose = () => { }, start_index = 0 } = props;

    const { tabs, setTabs, index, help, update, setIndex, editProps, next, prev, refs, getVal } =
        useTabs(fields, fields[start_index]?.key);

    const proceed = () => {



        if (index === fields[fields.length - 1].key) {
            onSave(tabs);
        } else {
            next();
        }
    };

    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: () => onClose(false) },
            { key: KBD.SHIFT_TAB, action: () => prev(index) },
            { key: KBD.TAB, action: () => proceed() },
            { key: KBD.ENTER, action: () => proceed() },
            { key: KBD.ARROW_UP, action: () => prev(index) },
            { key: KBD.ARROW_DOWN, action: () => next() },
            { key: KBD.PAGE_DOWN, action: () => onSave(tabs) },
        ];
        return listen(controller, ROUTES.REPORTS.FILTER_EDIT, actions, () => { }, [
            KBD.TAB,
            KBD.SHIFT_TAB,
            KBD.ENTER,
            KBD.PAGE_DOWN,
            KBD.ESCAPE,
            KBD.ARROW_DOWN,
            KBD.ARROW_UP
        ]);
    }, [index, tabs]);

    useEffect(() => {
        if (refs?.current[index]) refs.current[index].focus();
    }, [index]);

    return (
        <div style={{ "minWidth": "400px" }}>
            <div className="shim" /><div className="shim" />
            {props.children({ tabs, index, setTabs, setIndex, update, next, editProps,  getVal, refs, proceed })}
            <div className="shim" /><div className="shim" />
            <Status type="active"><InfoIcon />{help}</Status>
        </div>
    )

}
